module.exports = __webpack_public_path__ + "static/netyourself-ffcf5e54cc264684c768305113dd5584.svg";